import { AggregateQuerySpec, CellMatch, DrillDownColumn, DrillDownHeaderAggregate, KpiCellConfig, QueryDrillDownConfig } from "./types";
import { combineFilters } from "./useAggregate";

// Os drill configs são construídos NO RENDER a partir dos MESMOS objetos de filtro passados ao
// useAggregate (nunca recalculados no clique) — garante que as linhas da modal correspondem ao
// número mostrado, mesmo atravessando viragens de dia/semana/mês ou mudanças de filtros globais.

export type DrillDownQueryOptions = {
    title: string;
    fieldsQuery: string;
    defaultSort: string;
    columns: Array<DrillDownColumn>;
    rowRoute?: (item: any) => string | null;
    headerAggregate?: DrillDownHeaderAggregate;
    queryDescription?: string;
};

export const drillDownFromAggregate = (spec: AggregateQuerySpec, filter: any, options: DrillDownQueryOptions) => {
    const drill: QueryDrillDownConfig = {
        kind: "query",
        entity: spec.entity,
        filter: combineFilters(spec.fixedFilter, filter),
        ...options,
    };
    return drill;
};

export const cellMatchToFilter = (match: CellMatch) => {
    const clauses: Array<any> = [];
    if (match.statuses) clauses.push({ status: { _in: match.statuses } });
    if (match.services) clauses.push({ service: { _in: match.services } });
    if (clauses.length === 0) return null;
    const filter = clauses.length === 1 ? clauses[0] : { _and: clauses };
    return filter;
};

// Espelha a semântica de countWhere: arrays ausentes no match = "todos" (cláusula omitida);
// células sumOfCells = _or dos matches-membro (recursivo).
export const kpiCellMatchFilter = (cells: Array<KpiCellConfig>, cellKey: string): any => {
    const cell = cells.find((candidate) => candidate.key === cellKey);
    if (!cell) return null;
    if (cell.match) return cellMatchToFilter(cell.match);
    if (cell.sumOfCells) {
        const memberFilters = cell.sumOfCells.map((memberKey) => kpiCellMatchFilter(cells, memberKey)).filter(Boolean);
        if (memberFilters.length === 0) return null;
        return { _or: memberFilters };
    }
    return null;
};

export const drillDownForKpiCell = (
    spec: AggregateQuerySpec,
    baseFilter: any,
    cells: Array<KpiCellConfig>,
    cellKey: string,
    options: DrillDownQueryOptions
) => {
    const cellFilter = kpiCellMatchFilter(cells, cellKey);
    const drill: QueryDrillDownConfig = {
        kind: "query",
        entity: spec.entity,
        filter: combineFilters(combineFilters(spec.fixedFilter, baseFilter), cellFilter),
        ...options,
    };
    return drill;
};
